import type { GeneratedAlways } from 'kysely'
import { z } from 'zod'
import type { SyncMessage, SyncMessageStatusType } from '../common/types'

export interface ServerMessage extends SyncMessage {
  serverTs: GeneratedAlways<bigint>
  status: SyncMessageStatusType
}

export type OutboxMessage = SyncMessage

export const APP_METADATA_LAST_SYNC_TS_KEY = 'lastSyncTs'
export const APP_METADATA_NODE_ID_KEY = 'nodeId'

export const AppMetadataSchema = z.object({
  key: z.string(),
  value: z.string().nullable(),
})

export interface AppMetadata {
  key: string
  value: string | null
}

export interface SyncDatabase {
  message: SyncMessage
}

export interface SyncClientDatabase {
  message: OutboxMessage
  appMetadata: AppMetadata
}

export interface SyncServerDatabase {
  message: ServerMessage
}
